export const answers = [
  { id: 'a1', answer: 'nigdy lub prawie nigdy', score: 0 },
  { id: 'a2', answer: 'rzadko', score: 1 },
  { id: 'a3', answer: 'czasami', score: 2 },
  { id: 'a4', answer: 'często', score: 3 },
  { id: 'a5', answer: 'zawsze lub prawie zawsze', score: 4 },
];
